module.exports = __webpack_public_path__ + "static/assets/0cb6638e17e8c21c8563bc532a010470.png";